import styled from 'styled-components';
import { Body2SemiBold, Body5Regular, Body5SemiBold } from 'styles/Global/typography';
import { BackgroundColor, BorderColor, PrimaryColor, TextColor } from 'styles/Global/colorSemantic';

export const ProcessBox = ({ index, title, secondTitle, subTitle, notice }: { index: number; title: string; secondTitle?: string; subTitle: string; notice?: React.ReactNode }) => {
    return (
        <>
            <CardContainer>
                <ExplainContainer>
                    <NumContainer>
                        <Body5SemiBold $color={PrimaryColor.color_primary_normal}>{index + 1}</Body5SemiBold>
                    </NumContainer>
                    <ExplainTextContainer>
                        <div>
                            <Body2SemiBold $color={secondTitle ? PrimaryColor.color_primary_normal : TextColor.color_text_normal}>{title}</Body2SemiBold>
                            {secondTitle && <Body2SemiBold>{secondTitle}</Body2SemiBold>}
                        </div>
                        <Body5Regular $color={TextColor.color_text_light}>{subTitle}</Body5Regular>
                    </ExplainTextContainer>
                </ExplainContainer>
                {notice && <NoticeContainer>{notice}</NoticeContainer>}
            </CardContainer>
        </>
    );
};

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${BorderColor.color_border_light};
    border-radius: 8px;
    gap: 12px;
    padding: 16px 16px 18px 16px;
`;

const ExplainContainer = styled.div`
    display: flex;
    border-radius: 8px;
    gap: 8px;
`;

const ExplainTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    gap: 2px;
`;

const NoticeContainer = styled.div`
    display: flex;
    border-radius: 8px;
    background-color: ${BackgroundColor.color_background_neutral};
    padding: 10px 16px 12px 16px;
`;

const NumContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${BackgroundColor.color_background_primary_normal};
    border-radius: 999px;
    width: 24px;
    min-width: 24px;
    height: 24px;
`;
